export const getEmailOnClick = (url: string, text: string) => () => {
    const body = `${encodeURIComponent(url)}
%0D%0A
%0D%0A`
    location.href = `mailto:?subject=${text}&body=${body}`
}
